import { TFunction } from 'i18next';
import { Segment, SegmentType } from '~src/interfaces/segment.interface';

import { translateContent } from './translationServices';

export function getNameOfSegment(t: TFunction, segment: Segment, withAttribute = true): string {
  switch (segment.type) {
    case SegmentType.Group:
      return `${segment.meta && segment.meta.option_name ? translateContent(segment.meta.option_name) : ''} ${
        withAttribute
          ? `(${
              segment.meta && segment.meta.attribute_name ? translateContent(segment.meta.attribute_name) : ''
            })`
          : ''
      }`;
    case SegmentType.Company:
    case SegmentType.User:
      return segment.meta.name;
    case SegmentType.Team:
      return t('x.segments.team_name').replace('%s', segment.meta.manager_name);
    case SegmentType.Admins:
      return t('x.segments.admin_name');
    case SegmentType.Anonymous:
      return '?';
  }
}
